import FavoriteButton from '../FavoriteButton';
import FishPlaceholder from '../FishPlaceholder';
import PostTypeBadge from './PostTypeBadge';

export function typeToLabel(type) {
	switch (type) {
		case 'actor':
			return 'Aktør';
		case 'person':
			return 'Person';
		default:
			break;
	}
}

export default function GalleryResultPreview({ item }) {
	let image =
		item?.actorFields?.logoImage || item?.personFields?.profileImage;
	let type = item?.contentType?.node?.graphqlSingleName;
	let typeLabel = typeToLabel(type);
	let id = item?.databaseId;

	if (
		item?.actorTypes?.nodes?.filter(o => o.name === 'Organisasjoner')
			.length > 0
	) {
		type = 'organization';
		typeLabel = 'Organisasjon';
	}

	return (
		<article class="bg-white border border-gray shadow-sm rounded-b-lg text-sm">
			<div class="flex justify-between">
				<PostTypeBadge type={type} label={typeLabel} />
				<FavoriteButton id={id} />
			</div>
			<a href={item?.link} class="block no-underline p-5 group">
				<div class="h-32 w-32 bg-light-gray rounded-lg overflow-hidden relative mb-4">
					{image?.node ? (
						<img
							src={image.node.sourceUrl}
							alt={image.node.altText}
							class="absolute w-full h-full inset-0 object-cover"
						/>
					) : (
						<FishPlaceholder />
					)}
				</div>
				<h2 class="inline font-display text-xl font-bold group-hover:underline transition-colors leading-tight">
					{item?.title}
				</h2>
				{type === 'person' ? (
					<div
						class="text-sm text-muted leading-snug mt-3"
						dangerouslySetInnerHTML={{
							__html: item?.personFields?.specialPosition
						}}
					/>
				) : (
					<ul class="text-sm text-muted mt-3 leading-snug flex flex-col gap-y-1.5 mb-0">
						{item?.industries?.nodes?.length >= 1 && (
							<li class="flex gap-x-1.5">
								<span class="w-5 text-center flex-shrink-0">
									<i class="far fa-industry-alt"></i>
								</span>
								{item.industries.nodes.map((term, i) =>
									i === 0 ? term.name : `, ${term.name}`
								)}
							</li>
						)}
						{item?.species?.nodes?.length >= 1 && (
							<li class="flex gap-x-1.5">
								<span class="w-5 text-center flex-shrink-0">
									<i class="far fa-fish"></i>
								</span>
								{item.species.nodes.map((term, i) =>
									i === 0 ? term.name : `, ${term.name}`
								)}
							</li>
						)}
						{item?.counties?.nodes?.length >= 1 && (
							<li class="flex gap-x-1.5">
								<span class="w-5 text-center flex-shrink-0">
									<i class="far fa-map-marker-alt"></i>
								</span>
								{item.counties.nodes.map((term, i) =>
									i === 0 ? term.name : `, ${term.name}`
								)}
							</li>
						)}
					</ul>
				)}
			</a>
		</article>
	);
}
